import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function ComparisonArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-comparison"]} />;
}